import { DateService } from 'common/services/date-service';
import translations from 'client/internationalization/translation-map.json';
import { HierarchyLevelType } from 'common/interfaces/hierarchy-entities';

// top-down order of the levels a design can sit under
export const DESIGN_ANCESTOR_LEVELS = [
  HierarchyLevelType.Archive,
  HierarchyLevelType.Country,
  HierarchyLevelType.Field,
  HierarchyLevelType.Site,
  HierarchyLevelType.Well,
  HierarchyLevelType.Wellbore,
] as const;

export type TAncestorLevel = (typeof DESIGN_ANCESTOR_LEVELS)[number];

export const isDesignAncestorLevel = (entityType: HierarchyLevelType): entityType is TAncestorLevel => {
  return (DESIGN_ANCESTOR_LEVELS as readonly HierarchyLevelType[]).includes(entityType);
};

export const getLastPushedLabel = (t: (key: string, options?: Record<string, string>) => string, lastSyncedOutAt?: string | null) => {
  if (!lastSyncedOutAt) {
    return null;
  }
  const time = DateService.formatTime(lastSyncedOutAt);

  if (DateService.isToday(lastSyncedOutAt)) {
    return t(translations.design_lastSyncedToday, { time });
  }
  if (DateService.isYesterday(lastSyncedOutAt)) {
    return t(translations.design_lastSyncedYesterday, { time });
  }
  return t(translations.design_lastSynced, { date: DateService.formatDate(lastSyncedOutAt), time });
};
